<template>
  <v-card
    class="ml-3 mt-2 background"
    height="100vh"
    :style="{ backgroundImage: 'url(' + background_image + ')' }"
    >
    <!-- Toolbar -->
    <v-toolbar class="white--text" color="indigo" dense flat>
      <!-- Titolo -->
      <v-toolbar-title> Notifiche e Avvisi</v-toolbar-title>
    </v-toolbar>
        <!-- Menù radiale -->
        <MenuRadiale
        :key="key_menu_radiale"
          :menu_items="menu_tree"
          :size="altezza - 110"
          @click_settore="clickMenu($event)"
        />
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import MenuRadiale from "@/components/QNOTICE/MenuRadiale.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "HomeNotice",
  components: {
    MenuRadiale,
    SnackbarQV,
  },
  data() {
    return {
      // Variabili di supporto
      menu_selected: null,
      altezza: 0,
      key_menu_radiale: 0,
      visualizza_albero: false,
      visualizza_preferiti: false,
      background_image: "",
      id_modulo: 183,
      caricamento_dati: false,
      user_abilitato: 0,

      modulo_menu_selez: null,

      // Modali.
      dialog_task: false,
      dialog_moduli_menu: false,

      // Array
      menu_data: [],
      menu_data_preferiti: [],
      menu_tree: [],
      menu_radiale_items: [],
    };
  },
  methods: {
    async salvataggio_effettuato() {
      this.caricamento_dati = true;
      this.dialog_moduli_menu = false;
      await this.getMenu();
      this.$refs.SnackbarQV.print(
        "success",
        "Salvataggio avvenuto con successo"
      );
    },

    opentree() {
      this.menu_selected = "/tree";
      this.$router.push("/tree");
    },

    clickMenu(arg) {
      
      this.$router.push(arg.link_menu).catch((err) => {
        console.error(err);
        // eslint-disable-line no-unused-vars
      });

      // Se la rotta non viene trovata e reindirizza ad "home", evita recursione menù.
      if (this.$router.currentRoute.path == "/home") this.menu_selected = null;
    },

    clickModulo(item) {
      if (this.user_abilitato == 1) {
        this.modulo_menu_selez = item;
        this.dialog_moduli_menu = true;
      }
    },

    getBackground() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getbackgroundmodulo",
          token: localStorage.user_token,
          id_modulo: this.id_modulo,
          filter: "validita=1",
        },
      };

      this.$store.dispatch("api6", request).then((res) => {
        if (res.status == 200) {
          if (res.data.result.sfondi.length > 0) {
            if (res.data.result.sfondi.length > 0)
              this.background_image = res.data.result.sfondi[0].sfondo;
          }
        }
      });
    },  

    setTree() {
      // Ricostruisci l'albero.
      this.menu_tree = [];
      this.buildTree(this.menu_data, this.menu_tree);

    },

    buildTree(arg, tree) {
      //var done = true;
      //var lev = path.split("/").length;
      arg.forEach((e) => {
        /* if (e.path.split("/").length > lev) {
          done = false;
        }
        if (e.path.substring(0, e.path.lastIndexOf("/")) == path) { */
          tree.push(JSON.parse(JSON.stringify(e)));
          tree[tree.length - 1].children = [];
        //}
      });

      /* if (done == false) {
        tree.forEach((e) => {
          this.buildTree(arg, e.children, e.path);
        });
      } */
    },

    async getMenu() {
      // Prende lista dei moduli menù.
      this.menu_data = [
          {
            id_modulo_menu: 2,
            des: "Notifiche",
            icon: "mdi-bell",
            text: "Notifiche",
            path: "/home/noticelist",
            link_menu: "/home/noticelist",
            validita: 1,
          },
          {
            id_modulo_menu: 3,
            des: "Avvisi",
            icon: "mdi-bell-alert",
            text: "Avvisi",
            path: "/home/notifiche",
            link_menu: "/home/notifiche",
            validita: 1,
          },
          {
            id_modulo_menu: 4,
            des: "Notifiche Push",
            icon: "mdi-square-rounded-badge",
            text: "Notifiche Push",
            path: "/home/notifichepush",
            link_menu: "/home/notifichepush",
            validita: 1,
          },
          {
            id_modulo_menu: 5,
            des: "Avvisi login",
            icon: "mdi-square-rounded-badge",
            text: "Avvisi login",
            path: "/home/avvisilogin",
            link_menu: "/home/avvisilogin",
            validita: 1,
          },
          {
            id_modulo_menu: 6,
            des: "Task Periodici",
            icon: "mdi-square-rounded-badge",
            text: "Task Periodici",
            path: "/home/taskperiodici",
            link_menu: "/home/taskperiodici",
            validita: 1,
          },
          ]

      // Crea l'albero e aggiorna il menù radiale.
      this.setTree();
      this.key_menu_radiale = !this.key_menu_radiale;
    },
  },

  async mounted() {
    this.caricamento_dati = true;
    let that = this;
    this.getBackground();
    this.getMenu();

    // Adatta l'altezza del menù radiale.
    this.altezza = window.innerHeight;
    window.addEventListener("resize", function () {
      that.altezza = window.innerHeight;
    });

  },

  watch: {

  },
};
</script>

<style scoped>
.star_colored {
  color: #ff9f00ff;
  transition: 0.15s;
}
.star_colored:hover {
  color: #ff9f0077;
  transition: 0.15s;
}
.star_normal {
  color: grey;
  transition: 0.15s;
}
.star_normal:hover {
  color: #ff9f0077;
  transition: 0.15s;
}

.background {
  width: 99% !important;

  background-color: #cccccc; /* Used if the image is unavailable */
  height: 98% !important; /* You must set a specified height */
  background-position: cover; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
  overflow: hidden !important; /* Resize the background image to cover the entire container */
}

.btn-snackbar {
  margin-top: -6rem;
  float: right !important;
  margin-right: -1rem !important;
}
</style>
